import React from 'react';
import ReactDOM from 'react-dom/client';
import './index26.css';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);